import React, {Component} from 'react'
import {Row, Col, Card, CardHeader, CardBody} from 'reactstrap'
import _ from 'lodash'
import moment from 'moment'

import BudgetBreakdown from "./BudgetBreakdown";
import HoursWorked from "./HoursWorked";
import BudgetChart from "./BudgetChart";
import Schedule from "./Schedule";
import ProjectActivityUserTimeModal from '../project/ProjectActivityUserTimeModal';

export default class ProjectAnalytics extends Component{

    state = {
        selectedBudget: null,
    }

    formatTimesheetDataForChart = (timesheets) => {
        const tsObj = _.groupBy(timesheets, ({timesheet_date}) => moment(timesheet_date).format('DD/MM/YYYY'))
        return Object.keys(tsObj)
            .sort((a, b) => moment(a).valueOf() - moment(b).valueOf())
            .map(date => {
                return Object.assign(
                    {date},
                    tsObj[date].reduce((carry, timesheet) => {
                        carry[timesheet.user.full_name] = carry[timesheet.user.full_name] || 0
                        carry[timesheet.user.full_name] += (timesheet.minutes_worked) ? timesheet.minutes_worked / 60 : 0
                        return carry
                    }, {})
                )
            })

    }

    getStackKeysForChart = (timesheets) => {
        return _.uniq(_.map(timesheets, ({user}) => user.full_name))
    }


    render(){

        const {project} = this.props
        const {selectedBudget} = this.state

        return (
            <div>
                <Row>
                    <Col style={{padding: '20px'}}><h1 className="ml-3">{project.project_id} - {project.name}</h1></Col>
                </Row>
                <Row>
                    <Col sm={12} md={12} lg={12}>
                        <Card className="m-3">
                            <CardHeader>
                                Budget & Hours Worked
                            </CardHeader>
                            <CardBody>
                                <BudgetChart
                                    data={this.formatTimesheetDataForChart(project.timesheets)}
                                    keys={this.getStackKeysForChart(project.timesheets)}/>
                            </CardBody>
                        </Card>

                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={6} lg={6}>
                        <Card className="m-3">
                            <CardHeader>
                                Budget Breakdown
                            </CardHeader>
                            <CardBody>
                                <BudgetBreakdown
                                    budgets={project.project_activity_budgets}
                                    onBudgetPressed={(budget) => this.setState({selectedBudget: budget})}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                    <Col sm={12} md={6} lg={6}>
                        <Card className="m-3">
                            <CardHeader>
                                Hours Worked
                            </CardHeader>
                            <CardBody>
                                <HoursWorked hours_worked={project.total_hours_by_month}/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={12} lg={12}>
                        <Card className="m-3">
                            <CardHeader>
                                Project Resource (Future)
                            </CardHeader>
                            <CardBody>
                                <Schedule
                                    data={project.future_user_schedules}/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {selectedBudget && <ProjectActivityUserTimeModal
                    isOpen={!!selectedBudget}
                    id={selectedBudget.id}
                    title={selectedBudget.project_activity_type.description}
                    toggle={() => this.setState({selectedBudget: null})}
                />}
            </div>

        )
    }

}